export default __webpack_public_path__ + "static/media/micOff.3a72f682.svg";